module.exports = __webpack_public_path__ + "static/media/airplane_clopuds_background.01e5aa4c.jpg";